import { value } from '@takeshape/util';
import { updateAuthentication } from "../util/authentication.js";
import { isServiceConfig } from "../util/config.js";
import { hasEveryKey } from "../util/has.js";
import { getHealthCheck } from "../util/health.js";
export const name = 'arize';
export const provider = {
    name,
    title: 'Arize',
    description: 'Build AI agents and applications that perform. End-to-end tracing, evaluation, and troubleshooting.',
    categories: ['ai', 'tracing'],
    links: [{ title: 'Homepage', url: 'https://arize.com/' }],
    serviceType: 'rest',
    createId: value(name),
    getFormSchema: value({
        type: 'object',
        properties: {
            spaceId: {
                title: 'SpaceID',
                type: 'string'
            },
            isEnterprise: {
                title: 'Enterprise Plan',
                description: 'Check this box if you are on an Arize Enterprise plan.',
                type: 'boolean'
            },
            authentication: {
                title: 'Authentication',
                description: 'The following properties are encrypted and are obscured on this form to ensure the security of your data.',
                type: 'object',
                properties: {
                    token: {
                        title: 'API Key',
                        type: 'string',
                        '@sensitive': true
                    }
                },
                required: ['token']
            }
        },
        required: ['spaceId', 'authentication']
    }),
    getFormConfig: value({
        order: ['spaceId', 'isEnterprise', 'authentication'],
        properties: {
            spaceId: {
                widget: 'singleLineText',
                instructions: 'SpaceID from Space Settings'
            },
            isEnterprise: {
                widget: 'checkbox'
            },
            authentication: {
                properties: {
                    token: {
                        widget: 'sensitiveField',
                        instructions: 'API Key from Space Settings'
                    }
                },
                order: ['token']
            }
        }
    }),
    getConfig(formData) {
        const config = {
            id: name,
            title: 'Arize',
            provider: name,
            serviceType: 'rest',
            authenticationType: 'bearer',
            options: {
                isEnterprise: formData.isEnterprise ?? false,
                spaceId: formData.spaceId,
                headers: {
                    'Grpc-Metadata-space_id': formData.spaceId,
                    'Grpc-Metadata-sdk-language': 'rest'
                }
            }
        };
        return updateAuthentication(config, formData, {
            type: 'bearer',
            prefix: ''
        });
    },
    isCompleteConfig: hasEveryKey(['authentication', 'options.spaceId', 'options.headers']),
    isServiceConfig: isServiceConfig(name, ['authentication.token', 'options.spaceId', 'options.headers']),
    getHealthCheck: getHealthCheck({
        checkName: 'ping',
        endpoint: 'https://api.arize.com/v1/log',
        requestMethod: 'POST',
        healthyResponseStatusCode: 400
    })
};
